import { Avatar, Flex, Spacer, Text } from "@chakra-ui/react";
import { DashboardReservasItem } from "core/features/dashboards/typings";
import colors from "core/resources/theme/colors";
import moment from "moment";
import CardDefault from "components/Cards/CardDefault";
import OutlineButton from "ui/components/Button/OutlineButton";
import { TagStatusReserva } from "components/Tags/TagStatusReserva";
import { useCurrentAuth } from "core/features/auth/auth.store";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { showError } from "infra/helpers/alerta";
import ModalDetalheReserva from "components/ModalDetalheReserva";
import { useState } from "react";

interface CardItemReservaProps {
  item: DashboardReservasItem;
}

function CardItemReserva({ item }: CardItemReservaProps) {
  const { auth } = useCurrentAuth();
  const { selecionar } = useCurrentTenant();
  const [isOpenModal, setIsOpenModal] = useState(false);

  const onSwitchTenant = (tenantId: string) => {
    const _tenant = auth.tenants?.find((tenant) => tenant.id === tenantId);

    if (_tenant) {
      selecionar(_tenant);

      setTimeout(() => {
        window.location.href = `/administracao/reservas?reservaId=${item.id}`;
      }, 100);
    } else {
      showError(
        "Ocorreu um erro ao trocar o condomínio. Tente atualizar a página."
      );
    }
  };

  return (
    <CardDefault mt="16px" p="16px">
      <Flex>
        <Avatar
          mr="16px"
          backgroundColor="#eceff2"
          color={colors.gray}
          name={item.pessoa?.nome}
          src={item.pessoa?.imagemUrl}
        />
        <Flex flexDir="column" w="60%">
          <Text fontSize="14px" fontWeight="bold">
            {item.pessoa.nome}
          </Text>

          <Flex>
            <Text fontSize="12px" fontWeight="300">
              {item.descricao}
            </Text>
          </Flex>

          {item.tenant ? (
            <Flex>
              <Text fontSize="11px" fontWeight="500">
                {item.tenant.nome}
              </Text>
            </Flex>
          ) : null}
        </Flex>
        <Spacer />
        <Flex
          flexDir="column"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          {item.statusId ? <TagStatusReserva statusId={item.statusId} /> : null}

          <Text fontSize="12px" fontWeight="300" mt="auto">
            {item.unidade.numero} -{" "}
            {moment(item.createdAt).format("DD/MM/YYYY")} às{" "}
            {moment(item.createdAt).format("HH:mm")}
          </Text>
        </Flex>
      </Flex>

      <Flex justifyContent="flex-end" mt="8px">
        <OutlineButton onClick={() => setIsOpenModal(true)}>
          Ver detalhes
        </OutlineButton>

        {item.tenant ? (
          <OutlineButton ml={3} onClick={() => onSwitchTenant(item.tenant!.id)}>
            Trocar condomínio e ir para a listagem
          </OutlineButton>
        ) : null}
      </Flex>

      {isOpenModal ? (
        <ModalDetalheReserva
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          reservaId={item.id}
        />
      ) : null}
    </CardDefault>
  );
}

export default CardItemReserva;
